/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Přečetl/a jsem a souhlasím s <a class="underline" href="${i.link}" target="_blank">podmínkami prodeje</a> a uznávám, že moje objednávka mě zavazuje k platbě.`
};

const da_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Jeg har læst og accepterer <a class="underline" href="${i.link}" target="_blank">salgsbetingelserne</a> og anerkender, at min ordre forpligter mig til betaling.`
};

const de_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Ich habe die <a class="underline" href="${i.link}" target="_blank">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere sie. Ich erkenne an, dass meine Bestellung zur Zahlung verpflichtet.`
};

const en_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `I have read and agree to the <a class="underline" href="${i.link}" target="_blank">terms and conditions of sale</a> and acknowledge that my order obliges me to pay for it.`
};

const es_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `He leído y acepto las <a class="underline" href="${i.link}" target="_blank">condiciones generales de venta</a> y reconozco que mi pedido me obliga a su pago.`
};

const fr_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `J'ai lu et accepte les <a class="underline" href="${i.link}" target="_blank">conditions générales de vente</a> et reconnais que ma commande m'oblige à son paiement.`
};

const hu_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Elfogadom az <a class="underline" href="${i.link}" target="_blank">általános szerződési feltételeket</a> és tudomásul veszem, hogy a rendelésem szállítja a fizetési kötelezettséget.`
};

const it_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Ho letto e accetto le <a class="underline" href="${i.link}" target="_blank">condizioni generali di vendita</a> e riconosco che il mio ordine comporta il pagamento.`
};

const nl_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Ik heb de <a class="underline" href="${i.link}" target="_blank">algemene voorwaarden</a> gelezen en ga akkoord. Ik erken dat mijn bestelling een betalingsverplichting inhoudt.`
};

const pl_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Przeczytałem i akceptuję <a class="underline" href="${i.link}" target="_blank">regulamin</a> i potwierdzam, że moje zamówienie zobowiązuje mnie do zapłaty.`
};

const pt_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Li e aceito os <a class="underline" href="${i.link}" target="_blank">termos e condições</a> e reconheço que meu pedido me obriga ao pagamento.`
};

const sv_checkout_tos_confirmation = /** @type {(inputs: { link: NonNullable<unknown> }) => string} */ (i) => {
	return `Jag har läst och accepterar <a class="underline" href="${i.link}" target="_blank">villkoren</a> och bekräftar att min beställning är bindande.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ link: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_tos_confirmation = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_tos_confirmation(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_tos_confirmation", locale)
	if (locale === "cs") return cs_checkout_tos_confirmation(inputs)
	if (locale === "da") return da_checkout_tos_confirmation(inputs)
	if (locale === "de") return de_checkout_tos_confirmation(inputs)
	if (locale === "en") return en_checkout_tos_confirmation(inputs)
	if (locale === "es") return es_checkout_tos_confirmation(inputs)
	if (locale === "fr") return fr_checkout_tos_confirmation(inputs)
	if (locale === "hu") return hu_checkout_tos_confirmation(inputs)
	if (locale === "it") return it_checkout_tos_confirmation(inputs)
	if (locale === "nl") return nl_checkout_tos_confirmation(inputs)
	if (locale === "pl") return pl_checkout_tos_confirmation(inputs)
	if (locale === "pt") return pt_checkout_tos_confirmation(inputs)
	return sv_checkout_tos_confirmation(inputs)
};
export { checkout_tos_confirmation as "checkout.tos_confirmation" }